export default {
  currentUser: { },
  currentGroups: []
}
